/** Hash cifrado (Blowfish), não o id numérico do banco. */
export function isPortalToken(value) {
    if (value == null || value === '') return false;
    return !/^\d+$/.test(String(value));
}

/**
 * Token de GET /portal/module/course/{token}.
 * Gestor (type 1 ou 2): hash do curso.
 * Aluno: hash da matrícula — o backend decripta e filtra por enrol.id.
 * A rota já cifrada prevalece sobre o objeto em memória.
 */
export function resolvePortalModuleToken({ userType, routeSlug, coursePortal } = {}) {
    if (isPortalToken(routeSlug)) return String(routeSlug);

    const type = Number(userType);
    const courseHash = coursePortal?.course?.id;
    const enrolHash = coursePortal?.id;

    if (type === 1 || type === 2) {
        return isPortalToken(courseHash) ? String(courseHash) : null;
    }
    if (isPortalToken(enrolHash)) return String(enrolHash);
    if (isPortalToken(courseHash)) return String(courseHash);
    return null;
}

/** Hash usado na URL /aluno/curso/:slug e na busca de módulos. */
export function moduleTokenFromEnrol(enrol, userType) {
    if (!enrol) return null;
    const type = Number(userType);
    if (type === 1 || type === 2) {
        if (isPortalToken(enrol.course?.id)) return String(enrol.course.id);
        if (isPortalToken(enrol.id)) return String(enrol.id);
        return null;
    }
    if (isPortalToken(enrol.id)) return String(enrol.id);
    if (isPortalToken(enrol.course?.id)) return String(enrol.course.id);
    return null;
}
